<template>
    <share-entity-dialog ref="base" collection="programs" :title="$t('programs.share_program')"
        :shared-toast="$t('programs.shared')" />
</template>

<script>
import ShareEntityDialog from "./ShareEntityDialog";

export default {
    name: "ShareProgramDialog",
    components: { ShareEntityDialog },
    methods: {
        show(entity) {
            this.$refs.base.show(entity)
        },
    }
}
</script>
